import { QueryClient, useQuery, useQueryClient } from "react-query";
import { firestore } from "@/services/firestore";

const invalidateTotalShopsQuery = (queryClient: QueryClient) => {
  // This function can be used to invalidate the total shops query
  // when a user is added or removed, ensuring the data is fresh.
  queryClient.invalidateQueries("totalShops");
};

const totalShopsQuery = () => ({
  queryKey: ["totalShops"],
  queryFn: async () => {
    // This function should return the total number of shops.
    return await firestore.getDocumentCount("/shops");
  },
  refetchOnWindowFocus: false,
});

export const useTotalShopsQuery = () => {
  return useQuery(totalShopsQuery());
};

export const useInvalidateTotalShopsQuery = () => {
  const queryClient = useQueryClient();
  return () => invalidateTotalShopsQuery(queryClient);
};
